import { Theme } from '@mui/material'

import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()((theme: Theme) => ({
  root: {
    display: 'flex',
    padding: theme.spacing(5),
    height: theme.spacing(32),
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing(6),
    backgroundColor: theme.palette.text.white,
    borderRadius: theme.spacing(1),
  },
  textInputContainer: {
    marginBottom: theme.spacing(-2),
  },
  templateNameCloudIcon: {
    display: 'flex',
    alignItems: 'center',
    '& img': {
      width: theme.spacing(3),
      height: theme.spacing(3),
      objectFit: 'contain',
    },
  },
  templateIcon: {
    height: theme.spacing(23.605),
    width: theme.spacing(29.5075),
  },
  textContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
  },
  heading: {
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '24px',
    color: theme.palette.labraText.primary,
    fontFamily: theme.typography.fontFamily,
    letterSpacing: '0.15px',
  },
  subHeading: {
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '20px',
    color: theme.palette.labraText.description,
    fontFamily: theme.typography.fontFamily,
    letterSpacing: '0.25px',
  },
  btn: {
    marginTop: theme.spacing(1),
  },
  exampleText: {
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '16px',
    color: theme.palette.labraText.description,
    fontFamily: theme.typography.fontFamily,
    letterSpacing: '0px',
  },
  radioWithRadio: {
    '& > div > div > div': {
      width: '100%',
    },
  },
  infoText: {
    fontWeight: 400,
    fontSize: '12px',
    lineHeight: '16px',
    letterSpacing: '0px',
    color: theme.palette.textField.main,
  },
  modalWpapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(5),
  },
  salesforceContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
  },
  radioButtonContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
}))
